import React from 'react';
import {
  DocumentTextIcon,
  CloudArrowUpIcon,
  CogIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';

const steps = [
  {
    icon: BeakerIcon,
    title: 'Navigate to Single Requirement',
    description: 'In the sidebar on the left, click "Single Requirement" to switch to the single requirement analysis view.'
  },
  {
    icon: CogIcon,
    title: 'Select Rules (Optional)',
    description: 'If you have uploaded a custom rules file, select it from the Batch Processing tab first. Otherwise, choose between PLM or FuSa default rules using the dropdown shown on the page.'
  },
  {
    icon: DocumentTextIcon,
    title: 'Enter Requirement Text',
    description: 'Type or paste your requirement text into the text area (up to 5,000 characters). Then click "Analyze Requirement" to start the analysis.'
  },
  {
    icon: CogIcon,
    title: 'Review Results',
    description: 'View which rules passed or have warnings. The tool shows a side-by-side comparison of your original requirement and an AI-suggested improvement, with differences highlighted.'
  },
  {
    icon: CloudArrowUpIcon,
    title: 'Edit & Re-analyze',
    description: 'Click "Edit" to modify the improved requirement text. Once satisfied, click "Re-analyze" to verify the updated requirement against the same rules and track improvement progress.'
  },
  {
    icon: CloudArrowUpIcon,
    title: 'Download Results',
    description: 'Click "Download JSON" to save the full analysis results (including rule checks, improvement rationale, and your edits) as a JSON file for your records.'
  }
];

function SingleRequirementGuide() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-6">
        {steps.map((step, index) => (
          <div
            key={index}
            className="group relative bg-white dark:bg-neutral-900 rounded-xl p-4 shadow-lg hover:shadow-xl transition-shadow"
          >
            {/* Step number badge */}
            <div className="absolute -top-2 -left-2 w-8 h-8 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-xs font-bold text-white">{index + 1}</span>
            </div>
            {/* Icon */}
            <div className="mb-4 inline-flex p-3 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-primary-900/30 dark:to-secondary-900/30 rounded-xl">
              <step.icon className="w-6 h-6 text-primary-600 dark:text-primary-400" />
            </div>
            {/* Content */}
            <h4 className="text-base font-bold text-neutral-900 dark:text-white mb-2">
              {step.title}
            </h4>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">
              {step.description}
            </p>
            {/* Connector line (not on last item) */}
            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-1/4 -right-7 transform -translate-y-1/2">
                <svg
                  className="w-12 h-6 text-primary-400 dark:text-primary-700"
                  fill="none"
                  viewBox="0 0 60 24"
                >
                  <path
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 12 H48 M48 12 L42 6 M48 12 L42 18 M48 12 L42 18"
                  />
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SingleRequirementGuide;
